var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-spacer'),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$route.meta.title))]),_c('v-spacer')],1),_c('indicacao-organizacao-lista-indicados')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }